import { render, staticRenderFns } from "./PackageVariantClosedPlus.vue?vue&type=template&id=20f760d0"
import script from "./PackageVariantClosedPlus.vue?vue&type=script&lang=js"
export * from "./PackageVariantClosedPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports